import Email from './email'
import * as Common from './common'
import Empty from './empty'
import NotEmpty from './notEmpty'
import Numeric from './numeric'
import Phone from './phone'
import MaxLength from './maxLength'
import MinLength from './minLength'
import Checked from './checked'
import Selected from './selected'
import * as helpers from './helper'
import validate from './validate'
import NewMaxLength from './newMaxLength'
import Alphanumeric from './alphanumeric'
import NewMinLength from './newMinLength'
import NewNotEmpty from './newNotEmpty'
import MaxValue from './maxValue'
import MinValue from './minValue'

export const checkInvalid = (errorData) => {
  return Object.keys(errorData).some(element => {
    return errorData[element] !== false
  })
}

export {
  Email,
  Common,
  Empty,
  NotEmpty,
  Numeric,
  Phone,
  MaxLength,
  MinLength,
  Checked,
  Selected,
  helpers,
  validate,
  Alphanumeric,
  NewMaxLength,
  NewMinLength,
  NewNotEmpty,
  MaxValue,
  MinValue
}
